import React from "react";
import { Link, withRouter } from "react-router-dom";

const ConfirmAccount = props => {
  return (
    <React.Fragment>
      <div className="text-center mt50">
        <h3>Your new password has been set</h3>
      </div>

      <div className="text-center mar-popup-image">
        <img src="/assets/svg/confirmSuccess.svg" alt="confirmed" />
      </div>
      <p className="mb20 text-center opacity">
        For security purposes, you will need to sign in with your new password.
      </p>
      <div className="text-center mt75">
        <Link to="/" className="btn continue active">
          Continue to Sign in
        </Link>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ConfirmAccount);
